const Suggestions = [

    {
        _id: 'A1B2C3',
        name: 'Omar Khaled',
        email: 'omar.kahled@fakemail.com',
        suggestion: 'Sea of Tranquility'
    },

    {
        _id: 'D4E5F6',
        name: 'Ahmed Ali',
        email: 'ahmed.ali@fakemail.com',
        suggestion: 'The Catcher in the Rye'
    },

    {
        _id: 'G7H8I9',
        name: 'Sara Mohamed',
        email: 'sara.mohamed@fakemail.com',
        suggestion: 'To Kill a Mockingbird'
    },

    {
        _id: 'J1K2L3',
        name: 'Laila Hassan',
        email: 'laila.hassan@fakemail.com',
        suggestion: 'The Final Gambit'
    },

    {
        _id: 'M4N5O6',
        name: 'Khaled Mansour',
        email: 'khaled.mansour@fakemail.com',
        suggestion: 'Brave New World'
    },

    {
        _id: 'P7Q8R9',
        name: 'Aya Ibrahim',
        email: 'aya.ibrahim@fakemail.com',
        suggestion: 'The Great Gatsby'
    },

    {
        _id: 'S1T2U3',
        name: 'Mohamed Tarek',
        email: 'mohamed.tarek@fakemail.com',
        suggestion: 'Moby-Dick'
    },

    {
        _id: 'V4W5X6',
        name: 'Nour Youssef',
        email: 'nour.youssef@fakemail.com',
        suggestion: 'Pride and Prejudice'
    },

    {
        _id: 'Y7Z8A9',
        name: 'Hassan Hamed',
        email: 'hassan.hamed@fakemail.com',
        suggestion: 'The Brothers Karamazov'
    },

    {
        _id: 'B1C2D3',
        name: 'Fatma Adel',
        email: 'fatma.adel@fakemail.com',
        suggestion: 'The Picture of Dorian Gray'
    },

    {
        _id: 'E4F5G6',
        name: 'Yara Sami',
        email: 'yara.sami@fakemail.com',
        suggestion: 'War and Peace'
    },

    {
        _id: 'H7I8J9',
        name: 'Mahmoud Fathy',
        email: 'mahmoud.fathy@fakemail.com',
        suggestion: 'Anna Karenina'
    },

    {
        _id: 'K1L2M3',
        name: 'Heba El-Sayed',
        email: 'heba.sayed@fakemail.com',
        suggestion: 'One Hundred Years of Solitude'
    },

    {
        _id: 'N4O5P6',
        name: 'Rami Salah',
        email: 'rami.salah@fakemail.com',
        suggestion: 'Crime and Punishment'
    },

    {
        _id: 'Q7R8S9',
        name: 'Salma Nabil',
        email: 'salma.nabil@fakemail.com',
        suggestion: 'The Lord of the Rings'
    },

    {
        _id: 'T1U2V3',
        name: 'Ali Zaki',
        email: 'ali.zaki@fakemail.com',
        suggestion: 'Fahrenheit 451'
    },

    {
        _id: 'W4X5Y6',
        name: 'Marwa Saad',
        email: 'marwa.saad@fakemail.com',
        suggestion: 'Don Quixote'
    },

    {
        _id: 'Z7A8B9',
        name: 'Tamer Shawky',
        email: 'tamer.shawky@fakemail.com',
        suggestion: 'The Odyssey'
    },

    {
        _id: 'C1D2E3',
        name: 'Hoda Ayman',
        email: 'hoda.ayman@fakemail.com',
        suggestion: 'The Alchemist'
    },

    {
        _id: 'F4G5H6',
        name: 'Samir Ghanem',
        email: 'samir.ghanem@fakemail.com',
        suggestion: 'The Kite Runner'
    }

];

export default Suggestions;
